import { useEffect, useRef, useState } from 'react'

export function useHoverOutside<T extends HTMLElement>() {
  const ref = useRef<T | null>(null)
  const [isHovered, setIsHovered] = useState(false)

  useEffect(() => {
    function handleMouseMove(event: MouseEvent) {
      if (!ref.current) return

      const isInside = ref.current.contains(event.target as Node);
      setIsHovered(isInside)
    }

    document.addEventListener('mousemove', handleMouseMove)
    return () => {
      document.removeEventListener('mousemove', handleMouseMove)
    }
  }, [])

  return { ref, isHovered }
}
